import loc from "./loc.webp";
import loc2 from "./loc2.webp";
import loc3 from "./loc3.webp";
import loc4 from "./loc4.webp";
import loc5 from "./loc5.webp";
import loc6 from "./loc6.webp";

const locationImages = [loc, loc2, loc3, loc4, loc5, loc6];
export default locationImages;
